import { ConfigProvider } from 'antd';
import { useLanguage } from '@steinpilz/react-ux/i10n';
import { ReactNode, useEffect, useState } from 'react';
import dayjs from 'dayjs';
import type { Locale } from 'antd/es/locale';

const localeLoaders: Record<string, () => Promise<{ default: Locale }>> = {
  de: () => import('antd/locale/de_DE'),
  en: () => import('antd/locale/en_US'),
  hu: () => import('antd/locale/hu_HU'),
};

type AntdLocaleProviderProps = {
  children: ReactNode;
};

export const AntdLocaleProvider = ({ children }: AntdLocaleProviderProps) => {
  const language = useLanguage();
  const [locale, setLocale] = useState<Locale | undefined>(undefined);

  useEffect(() => {
    dayjs.locale(language);
    const loader = localeLoaders[language] ?? localeLoaders.de;
    loader().then((mod) => setLocale(mod.default));
  }, [language]);
  return <ConfigProvider locale={locale}>{children}</ConfigProvider>;
};
